import ANTDButton from '../../../../shared/antd/ANTDButton'
import ANTDColumn from '../../../../shared/antd/ANTDColumn'
import ANTDInput from '../../../../shared/antd/ANTDInput'
import ANTDRow from '../../../../shared/antd/ANTDRow'
import ANTDSelect from '../../../../shared/antd/ANTDSelect'
import ANTDSpin from '../../../../shared/antd/ANTDSpin'
import Label from '../../../../shared/Label'
import PopUpConfirm from '../../../../shared/PopUpConfirm'
import { include } from '../../../../utils/javascript'
import catalogueSelector from '../../container/catalogueSelector.container'

const CatalogueSelector = ({
  showConfirmation,
  withAdd,
  index = 0,
  disabled,
}) => {
  const {
    t,
    popup,
    loader,
    isOpen,
    addLoader,
    searchValues,
    tempSelected,
    selectAttributes,
    onScroll,
    onInputSearch,
    handleClosePopup,
    handleAddNewItem,
    onDropdownVisible,
    handleSelectChange,
  } = catalogueSelector({ index })

  return (
    <ANTDRow gutter={10}>
      {selectAttributes?.map(
        (
          {
            className,
            hidden,
            options,
            tabKey,
            searchPlaceholder,
            disableInput,
            label,
            ...attr
          },
          index,
        ) =>
          !hidden && (
            <ANTDColumn md={8} sm={24} key={index} className={className}>
              <div style={{ marginLeft: -10 }}>
                <Label text={label} colon={false} />
              </div>
              <ANTDSelect
                {...attr}
                {...(!withAdd && {
                  showSearch: true,
                  onSearch: search => onInputSearch(search, tabKey),
                })}
                disabled={disabled}
                open={isOpen?.[tabKey]}
                style={{ width: '100%' }}
                filterOption={false}
                options={options}
                onChange={(id, option) =>
                  handleSelectChange({
                    type: tabKey,
                    option,
                    showConfirmation,
                  })
                }
                onPopupScroll={e => onScroll(e, tabKey)}
                onDropdownVisibleChange={visible =>
                  onDropdownVisible({ [tabKey]: visible })
                }
                dropdownRender={menu => (
                  <>
                    {withAdd && (
                      <div
                        style={{
                          padding: '5px 4px',
                        }}
                        className="d-flex"
                      >
                        <ANTDInput
                          style={{ marginRight: '8px' }}
                          placeholder={searchPlaceholder}
                          value={searchValues?.[tabKey] ?? ''}
                          disabled={disableInput}
                          onChange={e =>
                            onInputSearch(e?.target?.value, tabKey)
                          }
                          onKeyDown={e => e.stopPropagation()}
                        />

                        <ANTDButton
                          type="primary"
                          disabled={
                            !searchValues?.[tabKey]?.trim() ||
                            loader ||
                            include(
                              options?.map(({ label }) => label),
                              searchValues?.[tabKey],
                            )
                          }
                          loading={addLoader}
                          onClick={() =>
                            handleAddNewItem({ tabKey, showConfirmation })
                          }
                        >{`${t('btn_Add')} +`}</ANTDButton>
                      </div>
                    )}
                    {menu}
                    {loader && (
                      <ANTDSpin size="small" style={{ paddingLeft: 10 }} />
                    )}
                  </>
                )}
              />
            </ANTDColumn>
          ),
      )}
      <PopUpConfirm
        isOpen={popup?.open}
        onCancelModel={handleClosePopup}
        description={popup?.message}
        onAccept={() => {
          handleSelectChange({ showConfirmation: false, ...tempSelected })
          handleClosePopup()
        }}
        onReject={handleClosePopup}
      />
    </ANTDRow>
  )
}

export default CatalogueSelector
